import { z } from 'zod';

export const numericFieldSchema = z.preprocess(
  (value) => {
    // Convert empty string to undefined or any other value you consider as "empty"
    return value === '' ? undefined : value;
  },
  z.number().refine((val) => val !== undefined, {
    message: 'Field is required and must be a number.',
  })
);
